import "./SkeletonContainer.scss";

const SkeletonContainer = ({ className }: any) => {
  return <div className={`${className} Skeleton-Container`}></div>;
};
export default SkeletonContainer;
